import { MouseEvent, ReactNode } from 'react';

import cn from 'classnames';

import { Button } from '../UtilElements';

export interface ToggleButtonProps {
  value: string;
  children: ReactNode;
  selected?: boolean;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  className?: string;
}

const ToggleButton = ({
  value: _value,
  children,
  selected = false,
  onClick,
  disabled = false,
  className,
}: ToggleButtonProps) => {
  return (
    <Button
      variant='text'
      size='small'
      disabled={disabled}
      onClick={onClick}
      preventHoverStyles
      preventMinWidth
      className={cn('toggle-button', { 'toggle-button__selected': selected }, className)}
    >
      {children}
    </Button>
  );
};

export default ToggleButton;
